import { render, staticRenderFns } from "./MspForsageStatus.vue?vue&type=template&id=8dcff2de&"
import script from "./MspForsageStatus.vue?vue&type=script&lang=js&"
export * from "./MspForsageStatus.vue?vue&type=script&lang=js&"
import style0 from "./MspForsageStatus.vue?vue&type=style&index=0&id=8dcff2de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports